export default __webpack_public_path__ + "static/media/sportsbra-large-left-toobig.3a605460.jpg";